import { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { toast } from "sonner";
import { DollarSign, Camera, Upload, ArrowLeft, Fuel, UtensilsCrossed, Building2, MoreHorizontal, Banknote, CreditCard, Smartphone, Receipt, Download, Eye, EyeOff, Trash2, AlertTriangle, HandCoins, Landmark, Wallet, Settings, TrendingDown, TrendingUp, Clock, CheckCircle2, Circle, Navigation, Phone, RotateCcw, MapPin, CalendarClock, X } from "lucide-react";
import {
  resolverMensagem, renderTemplate, buildVarsFromPromissoria, buildNumeroWhatsApp, TEMPLATES_PADRAO,
} from "../lib/whatsappTemplates";

const API = `${window.location.origin}/api`;

export default function CaixaCarroPage() {
  const params = new URLSearchParams(window.location.search);
  const carroId = params.get('carro_id');
  const carroNome = decodeURIComponent(params.get('carro_nome') || '');

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.tipo === 'admin' || user.tipo === 'secretario';

  const [config, setConfig] = useState({ rota_id: null, periodo_inicio: null, periodo_fim: null, rota_nome: '' });
  const [caixas, setCaixas] = useState([]);
  const [caixaSelecionadoId, setCaixaSelecionadoId] = useState(null);
  const [rotas, setRotas] = useState([]);
  const [dividas, setDividas] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [tab, setTab] = useState('dividas');
  const [saidasVerificadas, setSaidasVerificadas] = useState({});
  const [recobrancas, setRecobrancas] = useState([]);
  const [zerarDialog, setZerarDialog] = useState(false);
  const [zerarSenha, setZerarSenha] = useState('');
  const [zerarLoading, setZerarLoading] = useState(false);
  const [debugRecobOpen, setDebugRecobOpen] = useState(false);
  const [debugRecobData, setDebugRecobData] = useState(null);
  const [debugRecobLoading, setDebugRecobLoading] = useState(false);

  // Payment dialog
  const [pagDialog, setPagDialog] = useState(false);
  const [pagPromissoria, setPagPromissoria] = useState(null);
  const [pagValor, setPagValor] = useState('');
  const [pagForma, setPagForma] = useState('');
  const [pagImagem, setPagImagem] = useState(null);
  const [pagLoading, setPagLoading] = useState(false);
  const pagFileRef = useRef(null);
  const pagCameraRef = useRef(null);

  // Saída dialog
  const [saidaDialog, setSaidaDialog] = useState(false);

  // Devolução dialog
  const [devolucaoDialog, setDevolucaoDialog] = useState(false);
  const [devolucaoProm, setDevolucaoProm] = useState(null);
  const [devolucaoValor, setDevolucaoValor] = useState('');
  const [devolucaoMotivo, setDevolucaoMotivo] = useState('');
  const [devolucaoLoading, setDevolucaoLoading] = useState(false);
  const [saidaValor, setSaidaValor] = useState('');
  const [saidaCategoria, setSaidaCategoria] = useState('');
  const [saidaImagem, setSaidaImagem] = useState(null);
  const [saidaLoading, setSaidaLoading] = useState(false);
  const saidaFileRef = useRef(null);
  const saidaCameraRef = useRef(null);

  // Config dialog
  const [configDialog, setConfigDialog] = useState(false);
  const [configForm, setConfigForm] = useState({ rota_id: '', periodo_inicio: '', periodo_fim: '', nome: '' });
  const [novoCaixaMode, setNovoCaixaMode] = useState(false);

  // Recibos dialog
  const [recibosDialog, setRecibosDialog] = useState(false);
  const [recibosData, setRecibosData] = useState([]);
  const [recibosCliente, setRecibosCliente] = useState('');

  // Recibo individual (saída)
  const [reciboIndividualDialog, setReciboIndividualDialog] = useState(false);
  const [reciboIndividualData, setReciboIndividualData] = useState(null);

  // Excluir movimentação
  const [deleteMovDialog, setDeleteMovDialog] = useState(false);
  const [movToDelete, setMovToDelete] = useState(null);

  // Entregar Valor dialog
  const [entregaDialog, setEntregaDialog] = useState(false);
  const [entregaValor, setEntregaValor] = useState('');
  const [entregaLoading, setEntregaLoading] = useState(false);

  // Agendamento de Atendimento dialog
  const [agendaDialog, setAgendaDialog] = useState(false);
  const [agendaProm, setAgendaProm] = useState(null);
  const [agendaDia, setAgendaDia] = useState('');
  const [agendaHora, setAgendaHora] = useState('');
  const [agendaLoading, setAgendaLoading] = useState(false);

  const DIAS_SEMANA_LABEL = {
    segunda: 'Segunda', terca: 'Terça', quarta: 'Quarta',
    quinta: 'Quinta', sexta: 'Sexta', sabado: 'Sábado'
  };
  // Horas de 08:00 a 19:00 em intervalos de 15 min
  const HORAS_AGENDA = (() => {
    const arr = [];
    for (let h = 8; h <= 19; h++) {
      const maxMi = h === 19 ? 0 : 45;
      for (let mi = 0; mi <= maxMi; mi += 15) {
        arr.push(`${String(h).padStart(2, '0')}:${String(mi).padStart(2, '0')}`);
      }
    }
    return arr;
  })();

  const openAgendarAtendimento = (d) => {
    setAgendaProm(d);
    setAgendaDia(d.agendamento?.dia_semana || '');
    setAgendaHora(d.agendamento?.hora || '');
    setAgendaDialog(true);
  };

  const salvarAgendamento = async () => {
    if (!agendaProm || !agendaDia) {
      toast.error('Selecione um dia da semana');
      return;
    }
    setAgendaLoading(true);
    try {
      const { data } = await axios.put(`${API}/promissorias/${agendaProm.id}/agendamento`, {
        dia_semana: agendaDia,
        hora: agendaHora || null,
      });
      toast.success('Agendamento salvo!');
      // Atualiza state local
      setDividas(prev => prev.map(x => x.id === agendaProm.id ? { ...x, agendamento: data.agendamento } : x));
      setAgendaDialog(false);
      // Recarrega para respeitar a nova ordenação
      loadDividas();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erro ao agendar');
    } finally {
      setAgendaLoading(false);
    }
  };

  const removerAgendamento = async () => {
    if (!agendaProm) return;
    setAgendaLoading(true);
    try {
      await axios.delete(`${API}/promissorias/${agendaProm.id}/agendamento`);
      toast.success('Agendamento removido');
      setDividas(prev => prev.map(x => x.id === agendaProm.id ? { ...x, agendamento: null } : x));
      setAgendaDialog(false);
      loadDividas();
    } catch (e) {
      toast.error(e?.response?.data?.detail || 'Erro ao remover');
    } finally {
      setAgendaLoading(false);
    }
  };

  useEffect(() => {
    if (carroId) {
      loadCaixas();
      loadRotas();
    }
  }, [carroId]);

  useEffect(() => {
    if (config.rota_id && config.periodo_inicio && config.periodo_fim) {
      loadDividas();
      loadResumo();
      loadRecobrancas();
    }
  }, [config]);

  const loadCaixas = async () => {
    try {
      const res = await axios.get(`${API}/caixa/${carroId}/configs`);
      setCaixas(res.data || []);
      if (res.data.length > 0) {
        const sel = caixaSelecionadoId ? res.data.find(c => c.id === caixaSelecionadoId) : res.data[0];
        const chosen = sel || res.data[0];
        setCaixaSelecionadoId(chosen.id);
        setConfig(chosen);
        setConfigForm({
          rota_id: chosen.rota_id || '',
          periodo_inicio: chosen.periodo_inicio || '',
          periodo_fim: chosen.periodo_fim || '',
          nome: chosen.nome || ''
        });
      } else {
        // Tentar carregar config legado (sem id)
        const legRes = await axios.get(`${API}/caixa/${carroId}/config`);
        if (legRes.data && legRes.data.rota_id) {
          setConfig(legRes.data);
          setCaixas([legRes.data]);
          setConfigForm({
            rota_id: legRes.data.rota_id || '',
            periodo_inicio: legRes.data.periodo_inicio || '',
            periodo_fim: legRes.data.periodo_fim || '',
            nome: legRes.data.nome || 'Caixa Principal'
          });
        }
      }
    } catch (e) { console.error(e); }
  };

  const loadConfig = loadCaixas;

  const loadRotas = async () => {
    try {
      const [ret, nv] = await Promise.all([
        axios.get(`${API}/rotas?carro_id=${carroId}&tipo=retorno`),
        axios.get(`${API}/rotas?carro_id=${carroId}&tipo=novas_vendas`)
      ]);
      const todas = [...ret.data, ...nv.data];
      const agrupadas = {};
      todas.forEach(r => {
        const key = r.nome.trim().toUpperCase();
        if (!agrupadas[key]) agrupadas[key] = { nome: r.nome.trim(), ids: [] };
        agrupadas[key].ids.push(r.id);
      });
      setRotas(Object.values(agrupadas).map(g => ({ nome: g.nome, id: g.ids.join(',') })));
    } catch (e) { console.error(e); }
  };

  const loadDividas = async () => {
    try {
      const cxId = caixaSelecionadoId ? `&caixa_id=${caixaSelecionadoId}` : '';
      const res = await axios.get(`${API}/caixa/${carroId}/dividas?_=1${cxId}`);
      const sorted = [...res.data].sort((a, b) => {
        const aQ = a.status === 'quitada' ? 1 : 0;
        const bQ = b.status === 'quitada' ? 1 : 0;
        return aQ - bQ;
      });
      setDividas(sorted);
    } catch (e) { console.error(e); }
  };

  const loadResumo = async () => {
    try {
      const cxId = caixaSelecionadoId ? `?caixa_id=${caixaSelecionadoId}` : '';
      const res = await axios.get(`${API}/caixa/${carroId}/resumo${cxId}`);
      setResumo(res.data);
    } catch (e) { console.error(e); }
  };

  const handleSaveConfig = async () => {
    try {
      const rotaSel = rotas.find(r => r.id === configForm.rota_id);
      if (novoCaixaMode) {
        await axios.post(`${API}/caixa/${carroId}/config`, {
          ...configForm,
          rota_nome: rotaSel?.nome || ''
        });
        toast.success("Novo caixa criado!");
      } else {
        await axios.put(`${API}/caixa/${carroId}/config`, {
          ...configForm,
          id: config.id || caixaSelecionadoId,
          rota_nome: rotaSel?.nome || ''
        });
        toast.success("Configuração salva!");
      }
      setConfigDialog(false);
      setNovoCaixaMode(false);
      loadCaixas();
    } catch (e) { toast.error("Erro ao salvar configuração"); }
  };

  const handleExcluirCaixa = async (caixaId, nomeCaixa) => {
    if (!window.confirm(`Tem certeza que deseja EXCLUIR o caixa "${nomeCaixa}"?\n\nEsta ação NÃO pode ser desfeita.`)) return;
    try {
      await axios.delete(`${API}/caixa/${carroId}/config/${caixaId}`);
      toast.success("Caixa excluído!");
      // Se excluiu o selecionado, limpa
      if (caixaSelecionadoId === caixaId) {
        setCaixaSelecionadoId(null);
        setConfig(null);
      }
      loadCaixas();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao excluir caixa");
    }
  };

  const handleToggleOcultar = async (caixaId, ocultoAtual) => {
    try {
      await axios.patch(`${API}/caixa/${carroId}/config/${caixaId}/visibilidade`, { oculto: !ocultoAtual });
      toast.success(!ocultoAtual ? "Caixa oculto dos vendedores" : "Caixa visível para todos");
      loadCaixas();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Erro ao alterar visibilidade");
    }
  };

  const handleSelectCaixa = (caixaId) => {
    const sel = caixas.find(c => c.id === caixaId);
    if (sel) {
      setCaixaSelecionadoId(caixaId);
      setConfig(sel);
      setConfigForm({
        rota_id: sel.rota_id || '',
        periodo_inicio: sel.periodo_inicio || '',
        periodo_fim: sel.periodo_fim || '',
        nome: sel.nome || ''
      });
    }
  };

  const openPagamento = (prom) => {
    setPagPromissoria(prom);
    setPagValor('');
    setPagForma('');
    setPagImagem(null);
    setPagDialog(true);
  };

  const loadRecobrancas = async () => {
    try {
      const cxId = caixaSelecionadoId ? `?caixa_id=${caixaSelecionadoId}` : '';
      const res = await axios.get(`${API}/caixa/${carroId}/recobrancas${cxId}`);
      setRecobrancas(res.data);
    } catch (e) { console.error(e); }
  };

  const handleVerificarComprovante = async (movId) => {
    try {
      const res = await axios.post(`${API}/caixa/pagamento/${movId}/verificar`);
      loadResumo();
      return res.data.verificado;
    } catch (e) { toast.error("Erro ao verificar"); }
  };

  const handleInvalidarComprovante = async (movId) => {
    try {
      await axios.post(`${API}/caixa/pagamento/${movId}/invalidar`);
      loadResumo();
      loadDividas();
      toast.success("Status atualizado");
    } catch (e) { toast.error("Erro ao invalidar"); }
  };

  const handleZerarCaixa = async () => {
    setZerarLoading(true);
    try {
      const res = await axios.post(`${API}/caixa/${carroId}/zerar`, { senha: zerarSenha, caixa_id: caixaSelecionadoId });
      toast.success(res.data.message);
      setZerarDialog(false);
      setZerarSenha('');
      loadResumo();
      loadDividas();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao zerar caixa");
    } finally { setZerarLoading(false); }
  };

  // Load debug recobrança data when dialog opens
  const loadDebugRecob = async () => {
    if (!carroId) return;
    setDebugRecobLoading(true);
    try {
      const cxId = caixaSelecionadoId ? `?caixa_id=${caixaSelecionadoId}` : '';
      const { data } = await axios.get(`${API}/caixa/${carroId}/debug-recobranca${cxId}`);
      setDebugRecobData(data);
    } catch (e) {
      toast.error('Erro ao carregar debug recobrança');
      setDebugRecobData(null);
    } finally { setDebugRecobLoading(false); }
  };

  useEffect(() => {
    if (debugRecobOpen) loadDebugRecob();
    // eslint-disable-next-line
  }, [debugRecobOpen]);

  const handleRelatorioPDF = async (modo = 'completo') => {
    try {
      const params = new URLSearchParams();
      if (caixaSelecionadoId) params.set('caixa_id', caixaSelecionadoId);
      if (modo === 'sem_recobrancas') params.set('incluir_recobrancas', 'false');
      if (modo === 'apenas_recobrancas') params.set('apenas_recobrancas', 'true');
      const qs = params.toString() ? `?${params.toString()}` : '';
      const resp = await fetch(`${API}/caixa/${carroId}/relatorio-pdf${qs}`, { headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}` } });
      if (!resp.ok) throw new Error('Erro');
      const blob = await resp.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      const nomes = {
        completo: 'relatorio_caixa.pdf',
        sem_recobrancas: 'relatorio_caixa_sem_recobrancas.pdf',
        apenas_recobrancas: 'relatorio_caixa_apenas_recobrancas.pdf',
      };
      a.download = nomes[modo] || 'relatorio_caixa.pdf';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
      toast.success("Relatório baixado!");
    } catch (e) { toast.error("Erro ao gerar relatório"); }
  };

  const handlePagamento = async () => {
    if (!pagForma || !pagValor || !pagImagem) {
      toast.error("Preencha todos os campos e anexe uma imagem");
      return;
    }
    setPagLoading(true);
    try {
      const formData = new FormData();
      formData.append('imagem', pagImagem);
      await axios.post(
        `${API}/caixa/${carroId}/pagamento-upload?promissoria_id=${pagPromissoria.id}&valor=${pagValor}&forma_pagamento=${pagForma}${caixaSelecionadoId ? `&caixa_id=${caixaSelecionadoId}` : ''}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      toast.success("Pagamento registrado!");
      setPagDialog(false);
      loadDividas();
      loadResumo();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao registrar pagamento");
    } finally { setPagLoading(false); }
  };

  const openSaida = () => {
    setSaidaValor('');
    setSaidaCategoria('');
    setSaidaImagem(null);
    setSaidaDialog(true);
  };

  const openDevolucao = (d) => {
    setDevolucaoProm(d);
    setDevolucaoValor('');
    setDevolucaoMotivo('');
    setDevolucaoDialog(true);
  };

  const handleDevolucao = async () => {
    if (!devolucaoValor || !devolucaoMotivo) {
      toast.error("Preencha o valor e o motivo");
      return;
    }
    const val = parseFloat(devolucaoValor);
    const restante = (devolucaoProm.valor_total || 0) - (devolucaoProm.valor_pago || 0);
    if (val > restante) {
      toast.error(`Valor máximo para devolução: R$ ${restante.toFixed(2)}`);
      return;
    }
    setDevolucaoLoading(true);
    try {
      await axios.post(`${API}/promissorias/${devolucaoProm.id}/devolucao`, { valor: val, motivo: devolucaoMotivo });
      toast.success("Devolução registrada!");
      setDevolucaoDialog(false);
      loadDividas();
      loadResumo();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao registrar devolução");
    } finally { setDevolucaoLoading(false); }
  };

  const handleSaida = async () => {
    if (!saidaCategoria || !saidaValor || !saidaImagem) {
      toast.error("Preencha todos os campos e anexe uma imagem");
      return;
    }
    setSaidaLoading(true);
    try {
      const formData = new FormData();
      formData.append('imagem', saidaImagem);
      await axios.post(
        `${API}/caixa/${carroId}/saida?valor=${saidaValor}&categoria=${saidaCategoria}${caixaSelecionadoId ? `&caixa_id=${caixaSelecionadoId}` : ''}`,
        formData,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      toast.success("Saída registrada!");
      setSaidaDialog(false);
      loadResumo();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao registrar saída");
    } finally { setSaidaLoading(false); }
  };

  const handleViewRecibos = async (prom) => {
    try {
      const response = await axios.get(`${API}/promissorias/${prom.id}/pagamentos`);
      const pags = response.data.pagamentos || [];
      const comImagem = pags.filter(p => p.imagem_path);
      if (comImagem.length === 0) {
        toast.info("Esta promissória não possui recibos com imagem");
        return;
      }
      setRecibosData(comImagem);
      setRecibosCliente(prom.cliente_nome);
      setRecibosDialog(true);
    } catch (error) {
      toast.error("Erro ao carregar recibos");
    }
  };

  const handleToggleVerificado = async (promId) => {
    try {
      const res = await axios.post(`${API}/promissorias/${promId}/verificar`);
      setDividas(prev => prev.map(d => d.id === promId ? {...d, verificado: res.data.verificado} : d));
    } catch (e) {
      toast.error("Erro ao marcar verificado");
    }
  };

  const handleDownloadRecibo = async (imagem_path, forma, valor, cliente) => {
    try {
      const response = await axios.get(`${API}/caixa/imagem/${imagem_path}`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement('a');
      link.href = url;
      const ext = imagem_path.split('.').pop() || 'jpg';
      const formaStr = (forma || '').replace(/\s+/g, '_');
      const valorStr = valor ? valor.toFixed(2).replace('.', ',') : '0';
      const clienteStr = (cliente || '').replace(/\s+/g, '_').substring(0, 30);
      link.download = `recibo_${formaStr}_${valorStr}_${clienteStr}.${ext}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      toast.error("Erro ao baixar arquivo");
    }
  };

  const isPdf = (path) => path && path.toLowerCase().endsWith('.pdf');

  const RenderComprovante = ({ path, alt }) => {
    if (!path) return null;
    if (isPdf(path)) {
      return <iframe src={`${API}/caixa/imagem/${path}`} title={alt} className="w-full h-80 border-0" />;
    }
    return <img src={`${API}/caixa/imagem/${path}`} alt={alt} className="w-full max-h-80 object-contain bg-white" onError={(e) => { e.target.style.display = 'none'; }} />;
  };

  const handleViewReciboSaida = (mov) => {
    setReciboIndividualData(mov);
    setReciboIndividualDialog(true);
  };

  const handleEntregaValor = async () => {
    const val = parseFloat(entregaValor);
    if (!val || val <= 0) { toast.error("Informe um valor válido"); return; }
    setEntregaLoading(true);
    try {
      await axios.post(`${API}/caixa/${carroId}/entrega-valor`, { valor: val, caixa_id: caixaSelecionadoId });
      toast.success(`R$ ${val.toFixed(2)} entregue ao caixa do carro!`);
      setEntregaDialog(false);
      setEntregaValor('');
      loadResumo();
    } catch (e) {
      toast.error(e.response?.data?.detail || "Erro ao entregar valor");
    } finally { setEntregaLoading(false); }
  };

  const handleDeleteMov = async () => {
    if (!movToDelete) return;
    try {
      await axios.delete(`${API}/caixa/movimentacao/${movToDelete.id}`);
      toast.success("Movimentação excluída com sucesso");
      setDeleteMovDialog(false);
      setMovToDelete(null);
      loadDividas();
      loadResumo();
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erro ao excluir");
    }
  };

  const formaLabel = { dh_em_maos: 'DH EM MÃOS', pix: 'PIX', credito: 'CRÉDITO', debito: 'DÉBITO' };
  const formaIcon = { dh_em_maos: Banknote, pix: Smartphone, credito: CreditCard, debito: CreditCard };
  const catLabel = { combustivel: 'COMBUSTÍVEL', almoco: 'ALIMENTAÇÃO', hotel: 'HOTEL', extras: 'EXTRAS', deposito_conta: 'DEPÓSITO EM CONTA' };
  const catIcon = { combustivel: Fuel, almoco: UtensilsCrossed, hotel: Building2, extras: MoreHorizontal, deposito_conta: Landmark };

  const toCG = (iso) => {
    if (!iso) return '';
    try {
      const d = new Date(iso);
      return d.toLocaleString('pt-BR', { timeZone: 'America/Campo_Grande', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
    } catch { return iso.slice(0, 16); }
  };
  const toCGTime = (iso) => {
    if (!iso) return '';
    try {
      return new Date(iso).toLocaleString('pt-BR', { timeZone: 'America/Campo_Grande', hour: '2-digit', minute: '2-digit' });
    } catch { return iso.slice(11, 16); }
  };

  return (
    <div className="space-y-5" data-testid="caixa-carro-page">
      {/* Header */}
      <div className="bg-gradient-to-r from-slate-800 to-slate-700 rounded-xl p-4 text-white">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <Button variant="ghost" size="sm" onClick={() => window.history.back()} className="text-white hover:bg-white/10" data-testid="back-btn">
              <ArrowLeft className="h-5 w-5" />
            </Button>
            <div className="flex items-center gap-3">
              <div className="p-2 bg-white/10 rounded-lg">
                <Wallet className="h-6 w-6 text-emerald-400" />
              </div>
              <div>
                <h2 className="text-xl font-bold tracking-tight">Caixa — {carroNome}</h2>
                {config.rota_nome ? (
                  <p className="text-sm text-slate-300 flex items-center gap-1">
                    <Clock className="h-3 w-3" />
                    {config.nome ? `${config.nome} | ` : ''}{config.rota_nome} | {config.periodo_inicio} a {config.periodo_fim}
                  </p>
                ) : (
                  <p className="text-sm text-slate-400">Sem configuração</p>
                )}
                {caixas.length > 1 && (
                  <div className="flex gap-1 mt-1 flex-wrap">
                    {caixas.map(cx => (
                      <button key={cx.id} onClick={() => handleSelectCaixa(cx.id)}
                        className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full transition-colors ${cx.id === caixaSelecionadoId ? 'bg-white text-slate-800 font-bold' : 'bg-white/20 text-white hover:bg-white/30'}`}
                        title={cx.oculto ? 'Oculto para vendedores' : ''}
                        data-testid={`select-caixa-${cx.id}`}>
                        {cx.oculto && <EyeOff className={`h-3 w-3 ${cx.id === caixaSelecionadoId ? 'text-slate-600' : 'text-white'}`} />}
                        {cx.nome || 'Caixa'}
                      </button>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="flex gap-2">
            {isAdmin && (
              <Button variant="outline" size="sm" onClick={() => setConfigDialog(true)} className="border-white/20 text-white hover:bg-white/10 gap-1" data-testid="config-caixa-btn">
                <Settings className="h-4 w-4" /> Configurar
              </Button>
            )}
            <Button size="sm" className="bg-red-500 hover:bg-red-600 gap-1 font-semibold shadow-lg" onClick={openSaida} data-testid="saida-btn">
              <TrendingDown className="h-4 w-4" /> Saída
            </Button>
          </div>
        </div>
      </div>

      {/* Aviso DH EM MÃOS > R$ 1000 */}
      {resumo && resumo.saldo_dh_em_maos > 1000 && (
        <div className="flex items-center gap-3 bg-red-600 text-white px-4 py-3 rounded-lg font-bold text-sm animate-pulse" data-testid="aviso-dh-excedente">
          <AlertTriangle className="h-5 w-5 flex-shrink-0" />
          DINHEIRO EM MÃOS EXCEDENTE DE 1.000,00 DEPOSITE EM CONTA!
        </div>
      )}

      {/* Resumo Cards */}
      {resumo && (
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {[
            { key: 'dh_em_maos', label: 'DH EM MÃOS', value: resumo.saldo_dh_em_maos, bg: 'bg-emerald-600', iconBg: 'bg-emerald-500' },
            { key: 'pix', label: 'PIX', value: resumo.recebimentos.pix, bg: 'bg-blue-600', iconBg: 'bg-blue-500' },
            { key: 'credito', label: 'CRÉDITO', value: resumo.recebimentos.credito, bg: 'bg-purple-600', iconBg: 'bg-purple-500' },
            { key: 'debito', label: 'DÉBITO', value: resumo.recebimentos.debito, bg: 'bg-orange-600', iconBg: 'bg-orange-500' },
            { key: 'saidas', label: 'SAÍDAS', value: resumo.saidas.total, bg: 'bg-red-600', iconBg: 'bg-red-500' },
          ].map(c => {
            const Icon = c.key === 'saidas' ? TrendingDown : (formaIcon[c.key] || DollarSign);
            return (
              <div key={c.key} className={`${c.bg} rounded-xl p-4 text-white relative overflow-hidden`} data-testid={`resumo-${c.key}`}>
                <div className={`absolute -top-2 -right-2 w-16 h-16 ${c.iconBg} rounded-full opacity-30`} />
                <div className="relative">
                  <Icon className="h-5 w-5 mb-2 opacity-80" />
                  <p className="text-xs font-medium opacity-80 uppercase tracking-wide">{c.label}</p>
                  <p className="text-xl font-bold mt-1">R$ {(c.value || 0).toFixed(2)}</p>
                  {c.key === 'saidas' && resumo.saidas.por_categoria && Object.keys(resumo.saidas.por_categoria).length > 0 && (
                    <div className="mt-2 space-y-0.5 border-t border-white/20 pt-2">
                      {Object.entries(resumo.saidas.por_categoria).map(([cat, val]) => (
                        <div key={cat} className="flex justify-between text-xs">
                          <span className="opacity-80">{catLabel[cat] || cat}</span>
                          <span className="font-semibold">R$ {(val || 0).toFixed(2)}</span>
                        </div>
                      ))}
                    </div>
                  )}
                  {c.key === 'dh_em_maos' && isAdmin && (
                    <Button size="sm" className="mt-3 w-full bg-white/20 hover:bg-white/30 text-white gap-1 text-xs font-semibold border-0"
                      onClick={() => { setEntregaValor(''); setEntregaDialog(true); }} data-testid="btn-entregar-valor">
                      <HandCoins className="h-3 w-3" /> Entregar Valor
                    </Button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* Contadores de Promissórias */}
      {dividas.length > 0 && (
        <div className="flex gap-3 text-sm">
          <span className="bg-gray-100 px-3 py-1 rounded-full font-medium" data-testid="count-total">Total: {dividas.length}</span>
          <span className="bg-amber-100 text-amber-700 px-3 py-1 rounded-full font-medium" data-testid="count-parciais">Parciais: {dividas.filter(d => d.status === 'observacao').length}</span>
          <span className="bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium" data-testid="count-quitadas">Quitadas: {dividas.filter(d => d.status === 'quitada').length}</span>
        </div>
      )}

      {/* Tabs + Action Buttons */}
      <div className="flex items-center justify-between">
        <div className="flex gap-1 bg-gray-100 p-1 rounded-lg w-fit">
          <button onClick={() => setTab('dividas')} data-testid="tab-dividas"
            className={`px-5 py-2 rounded-md font-medium text-sm transition-all ${tab === 'dividas' ? 'bg-white shadow-sm text-blue-700' : 'text-gray-500 hover:text-gray-700'}`}>
            Dívidas ({dividas.length})
          </button>
          <button onClick={() => setTab('recobranca')} data-testid="tab-recobranca"
            className={`px-5 py-2 rounded-md font-medium text-sm transition-all ${tab === 'recobranca' ? 'bg-white shadow-sm text-red-700' : 'text-gray-500 hover:text-gray-700'}`}>
            Recobrança ({recobrancas.length})
          </button>
          <button onClick={() => setTab('movimentacoes')} data-testid="tab-movimentacoes"
            className={`px-5 py-2 rounded-md font-medium text-sm transition-all ${tab === 'movimentacoes' ? 'bg-white shadow-sm text-blue-700' : 'text-gray-500 hover:text-gray-700'}`}>
            Movimentações
          </button>
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button variant="outline" size="sm" onClick={() => handleRelatorioPDF('completo')} className="gap-1" data-testid="btn-relatorio-pdf">
            <Download className="h-3.5 w-3.5" /> Relatório PDF
          </Button>
          <Button variant="outline" size="sm" onClick={() => handleRelatorioPDF('sem_recobrancas')}
            className="gap-1 text-purple-700 border-purple-300 hover:bg-purple-50" data-testid="btn-relatorio-pdf-sem-recob">
            <Download className="h-3.5 w-3.5" /> Relatório Sem Recobranças
          </Button>
          <Button variant="outline" size="sm" onClick={() => handleRelatorioPDF('apenas_recobrancas')}
            className="gap-1 text-orange-700 border-orange-300 hover:bg-orange-50" data-testid="btn-relatorio-pdf-so-recob">
            <Download className="h-3.5 w-3.5" /> Relatório Só Recobranças
          </Button>
          {isAdmin && (
            <Button variant="outline" size="sm" onClick={() => setDebugRecobOpen(true)}
              className="gap-1 text-blue-700 border-blue-300 hover:bg-blue-50" data-testid="btn-debug-recobranca">
              <AlertTriangle className="h-3.5 w-3.5" /> Debug Recob.
            </Button>
          )}
          {isAdmin && (
            <Button variant="outline" size="sm" onClick={() => { setZerarSenha(''); setZerarDialog(true); }}
              className="gap-1 text-red-600 border-red-300 hover:bg-red-50" data-testid="btn-zerar-caixa">
              <Trash2 className="h-3.5 w-3.5" /> Zerar Caixa
            </Button>
          )}
        </div>
      </div>

      {/* Dívidas Tab */}
      {tab === 'dividas' && (
        <div className="space-y-3">
          {!config.rota_id && (
            <Card className="border-dashed"><CardContent className="py-10 text-center text-gray-400">
              <Settings className="h-8 w-8 mx-auto mb-2 opacity-50" />
              <p>{isAdmin ? 'Configure a rota e o período para visualizar as dívidas.' : 'Aguardando configuração do administrador.'}</p>
            </CardContent></Card>
          )}
          {config.rota_id && dividas.length === 0 && (
            <Card className="border-dashed"><CardContent className="py-10 text-center text-gray-400">
              <p>Nenhuma dívida encontrada para esta rota e período.</p>
            </CardContent></Card>
          )}
          {dividas.map(d => {
            const restante = (d.valor_total || 0) - (d.valor_pago || 0);
            const pctPago = d.valor_total > 0 ? ((d.valor_pago || 0) / d.valor_total) * 100 : 0;
            const isQuitada = d.status === 'quitada';
            const isObservacao = d.status === 'observacao';
            const pags = d.pagamentos || [];
            const hasInvalidado = pags.some(pg => pg.invalido === true);
            // Aviso só aparece se o último pagamento via_caixa é inválido (vendedor ainda não reenviou)
            const lastCaixaPag = [...pags].reverse().find(pg => pg.via_caixa);
            const pendingReenvio = hasInvalidado && lastCaixaPag && lastCaixaPag.invalido === true;
            const borderColor = pendingReenvio ? 'border-l-red-500' : isQuitada ? 'border-l-green-500' : isObservacao ? 'border-l-amber-500' : 'border-l-blue-500';
            return (
              <Card key={d.id} data-testid={`divida-${d.id}`} className={`hover:shadow-md transition-shadow border-l-4 ${borderColor}`}>
                <CardContent className="p-4">
                  {pendingReenvio && (
                    <div className="mb-3 flex items-center gap-2 bg-red-50 border border-red-200 rounded-lg px-3 py-2" data-testid={`aviso-invalido-${d.id}`}>
                      <AlertTriangle className="h-4 w-4 text-red-600 flex-shrink-0" />
                      <span className="text-sm text-red-700 font-medium">Comprovante invalidado! Envie um novo comprovante.</span>
                    </div>
                  )}
                  <div className="flex justify-between items-start gap-3">
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 flex-wrap">
                        <p className="font-bold text-base truncate">{d.cliente_nome}</p>
                        {isQuitada && <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold">QUITADA</span>}
                        {isObservacao && <span className="text-xs bg-amber-100 text-amber-700 px-2 py-0.5 rounded-full font-semibold">C/ ENTRADA</span>}
                        {d.venda_avista && <span className="text-xs bg-emerald-100 text-emerald-700 px-2 py-0.5 rounded-full font-semibold">À VISTA</span>}
                        {d.verificado && <span className="text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded-full font-semibold flex items-center gap-0.5"><CheckCircle2 className="h-3 w-3" />OK</span>}
                        {pendingReenvio && <span className="text-xs bg-red-100 text-red-700 px-1.5 py-0.5 rounded-full font-semibold flex items-center gap-0.5"><AlertTriangle className="h-3 w-3" />INVALIDADO</span>}
                        {d.agendamento && !isQuitada && (
                          <span className="text-xs bg-indigo-100 text-indigo-700 px-2 py-0.5 rounded-full font-semibold flex items-center gap-1" data-testid={`agendamento-badge-${d.id}`}>
                            <CalendarClock className="h-3 w-3" />
                            {DIAS_SEMANA_LABEL[d.agendamento.dia_semana] || d.agendamento.dia_semana}
                            {d.agendamento.hora ? ` · ${d.agendamento.hora}` : ''}
                          </span>
                        )}
                      </div>
                      <p className="text-xs text-gray-500">{d.cliente_cidade} | {d.cliente_telefone}</p>
                      <div className="flex items-center gap-4 mt-2 text-sm">
                        <span>Total: <strong>R$ {(d.valor_total || 0).toFixed(2)}</strong></span>
                        {d.valor_pago > 0 && <span className="text-green-600">Pago: R$ {(d.valor_pago || 0).toFixed(2)}</span>}
                        {restante > 0 && <span className="font-bold text-red-600">Restante: R$ {restante.toFixed(2)}</span>}
                      </div>
                      {/* Progress bar */}
                      <div className="mt-2 h-1.5 bg-gray-100 rounded-full overflow-hidden">
                        <div className={`h-full rounded-full transition-all ${isQuitada ? 'bg-green-500' : 'bg-blue-500'}`} style={{width: `${Math.min(pctPago, 100)}%`}} />
                      </div>
                      <p className="text-xs text-gray-400 mt-1">Venc: {d.data_vencimento}</p>
                    </div>
                    <div className="flex flex-col gap-1 flex-shrink-0">
                      {/* Botão Verificado - apenas admin/secretário */}
                      {isAdmin && (
                        <Button variant="outline" size="sm"
                          onClick={() => handleToggleVerificado(d.id)}
                          className={`gap-1 text-xs ${d.verificado ? 'bg-blue-50 text-blue-700 border-blue-300 hover:bg-blue-100' : 'text-gray-500 hover:bg-gray-50'}`}
                          data-testid={`btn-verificado-${d.id}`}>
                          {d.verificado ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
                          {d.verificado ? 'Verificado' : 'Verificar'}
                        </Button>
                      )}
                      {restante > 0 && (
                        <Button size="sm" className="bg-green-600 hover:bg-green-700 gap-1 font-semibold" onClick={() => openPagamento(d)} data-testid={`pagar-${d.id}`}>
                          <DollarSign className="h-4 w-4" /> Pagar
                        </Button>
                      )}
                      {d.pagamentos && d.pagamentos.some(pg => pg.imagem_path) && (
                        <Button variant="outline" size="sm" onClick={() => handleViewRecibos(d)} className="gap-1 text-purple-600 hover:bg-purple-50" data-testid={`btn-recibos-caixa-${d.id}`}>
                          <Receipt className="h-4 w-4" /> Recibos
                        </Button>
                      )}
                      {d.cliente_localizacao && d.cliente_localizacao.lat && d.cliente_localizacao.lng && (
                        <Button variant="outline" size="sm" className="gap-1 text-green-600 hover:bg-green-50 border-green-300"
                          onClick={() => window.open(`https://maps.google.com/?q=${d.cliente_localizacao.lat},${d.cliente_localizacao.lng}`, '_blank')}
                          data-testid={`divida-ir-agora-${d.id}`}>
                          <Navigation className="h-4 w-4" /> Ir Agora
                        </Button>
                      )}
                      {isAdmin && restante > 0 && (
                        <Button variant="outline" size="sm" className="gap-1 text-yellow-700 border-yellow-400 bg-yellow-50 hover:bg-yellow-100 font-semibold"
                          onClick={() => openDevolucao(d)} data-testid={`btn-devolucao-${d.id}`}>
                          <RotateCcw className="h-4 w-4" /> Devolução
                        </Button>
                      )}
                      {!isQuitada && (
                        <Button variant="outline" size="sm"
                          className={`gap-1 ${d.agendamento ? 'text-indigo-700 border-indigo-300 bg-indigo-50 hover:bg-indigo-100' : 'text-indigo-600 hover:bg-indigo-50 border-indigo-200'}`}
                          onClick={() => openAgendarAtendimento(d)}
                          data-testid={`btn-agendar-${d.id}`}>
                          <CalendarClock className="h-4 w-4" />
                          {d.agendamento ? 'Editar Agenda' : 'Agendar'}
                        </Button>
                      )}
                    </div>
                  </div>
                  {/* Observações de devoluções */}
                  {d.devolucoes && d.devolucoes.length > 0 && (
                    <div className="mt-3 space-y-1" data-testid={`devolucoes-${d.id}`}>
                      {d.devolucoes.map((dev, idx) => (
                        <div key={dev.id || idx} className="flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-1.5">
                          <RotateCcw className="h-3.5 w-3.5 text-yellow-600 flex-shrink-0" />
                          <span className="text-xs text-yellow-800">
                            <strong>Devolução R$ {dev.valor?.toFixed(2)}</strong> — {dev.motivo}
                            <span className="text-yellow-600 ml-1">({dev.data?.split('T')[0]?.split('-').reverse().join('/')})</span>
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </CardContent>
              </Card>
            );
          })}
        </div>
      )}

      {/* Recobrança Tab */}
      {tab === 'recobranca' && (
        <div className="space-y-3">
          {recobrancas.length === 0 && (
            <p className="text-center text-gray-400 py-8">Nenhuma recobrança encontrada</p>
          )}
          {recobrancas.map(d => {
            const isQuitada = d.status === 'quitada';
            const isObservacao = d.status === 'observacao';
            const telefoneClean = (d.cliente_telefone || '').replace(/\D/g, '');
            const hasLocalizacao = d.cliente_localizacao && d.cliente_localizacao.lat && d.cliente_localizacao.lng;
            return (
              <div key={d.id} className="bg-white rounded-xl border shadow-sm p-4" data-testid={`recobranca-${d.id}`}>
                <div className="flex justify-between items-start mb-2">
                  <div className="flex items-center gap-2 flex-1">
                    <p className="font-bold text-base truncate">{d.cliente_nome}</p>
                    <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full font-semibold">RECOBRANÇA</span>
                    {d.dias_atraso > 0 && <span className="text-xs text-red-500">{d.dias_atraso} dias</span>}
                  </div>
                  <div className="text-right">
                    <p className="text-lg font-bold text-orange-600">R$ {((d.valor_total || 0) - (d.valor_pago || 0)).toFixed(2)}</p>
                    {d.valor_pago > 0 && <p className="text-xs text-gray-500">Pago: R$ {d.valor_pago?.toFixed(2)}</p>}
                  </div>
                </div>
                {d.cliente_telefone && (
                  <p className="text-xs text-gray-500 mb-1 flex items-center gap-1"><Phone className="h-3 w-3" />{d.cliente_telefone}</p>
                )}
                <div className="text-xs text-gray-500 mb-2">
                  Pedido: {d.numero_pedido} | Venc: {d.data_vencimento?.split('T')[0]?.split('-').reverse().join('/')}
                  {d.rota_nome && d.rota_nome !== '—' && (
                    <span className="ml-2 inline-flex items-center gap-1 bg-purple-50 text-purple-700 border border-purple-200 rounded px-1.5 py-0.5 font-medium">
                      <MapPin className="h-3 w-3" /> {d.rota_nome}
                    </span>
                  )}
                </div>
                <div className="flex gap-2 flex-wrap">
                  {!isQuitada && (
                    <Button size="sm" onClick={() => openPagamento(d)} className="gap-1 bg-green-600 hover:bg-green-700" data-testid={`recobranca-pagar-${d.id}`}>
                      <DollarSign className="h-4 w-4" /> Receber
                    </Button>
                  )}
                  {hasLocalizacao && (
                    <Button size="sm" variant="outline" className="gap-1 text-green-600 hover:bg-green-50 border-green-300"
                      onClick={() => window.open(`https://maps.google.com/?q=${d.cliente_localizacao.lat},${d.cliente_localizacao.lng}`, '_blank')}
                      data-testid={`recobranca-ir-agora-${d.id}`}>
                      <Navigation className="h-4 w-4" /> Ir Agora
                    </Button>
                  )}
                  {telefoneClean && (
                    <Button size="sm" variant="outline" className="gap-1 text-green-600 hover:bg-green-50 border-green-300"
                      onClick={async () => {
                        const num = buildNumeroWhatsApp(telefoneClean);
                        // Verifica se há template custom; se sim, usa custom + variáveis.
                        const { template } = await resolverMensagem("recobranca");
                        const ehCustom = template && template.trim() !== (TEMPLATES_PADRAO.recobranca || "").trim();
                        let textoFinal;
                        if (ehCustom) {
                          const cliente = { nome_completo: d.cliente_nome, telefone: telefoneClean };
                          const vars = buildVarsFromPromissoria({ promissoria: d, cliente });
                          // Override atraso_dias com o valor já calculado pelo backend (mais preciso)
                          if (d.dias_atraso != null) vars.atraso_dias = String(d.dias_atraso);
                          textoFinal = renderTemplate(template, vars);
                        } else {
                          // Fallback: mensagem hardcoded com dataVisita calculada por rota.
                          const hojeISO = new Date().toISOString().slice(0, 10);
                          const ativasRota = (dividas || []).filter(x =>
                            x.status !== 'quitada' && x.data_vencimento && x.data_vencimento >= hojeISO
                          ).sort((a, b) => (a.data_vencimento || '').localeCompare(b.data_vencimento || ''));
                          const proxVenc = ativasRota[0]?.data_vencimento;
                          const fmtBR = (iso) => iso ? `${iso.slice(8,10)}/${iso.slice(5,7)}/${iso.slice(0,4)}` : null;
                          const dataVisita = fmtBR(proxVenc);
                          const dataVencCliente = fmtBR(d.data_vencimento);
                          const valorRest = ((d.valor_total || 0) - (d.valor_pago || 0)).toFixed(2).replace('.', ',');
                          const primeiroNome = (d.cliente_nome || '').split(' ')[0] || 'Cliente';
                          const dias = d.dias_atraso || 0;
                          const linhas = [
                            `Olá, ${primeiroNome}.`,
                            ``,
                            `Aqui é da DAL COTONE MS. Estamos entrando em contato sobre a sua nota *Nº ${d.numero_pedido}*, com vencimento em *${dataVencCliente}* e atualmente *${dias} dia${dias !== 1 ? 's' : ''} em atraso*.`,
                            ``,
                            `Valor pendente: *R$ ${valorRest}*`,
                            ``,
                            `Como nossa empresa não trabalha com prazos estendidos, a quitação dentro da data combinada faz parte do compromisso firmado entre nós. Pedimos a gentileza de tratar essa pendência com a mesma seriedade do acordo inicial, para que possamos continuar oferecendo o melhor atendimento e novas vendas no seu cadastro.`,
                            ``,
                            dataVisita
                              ? `Estaremos passando na sua rota no dia *${dataVisita}* para realizar o recebimento. Por favor, tenha o valor disponível nessa data.`
                              : `Pedimos que entre em contato o quanto antes para definirmos a melhor forma de regularização.`,
                            ``,
                            `Caso o pagamento já tenha sido efetuado, por gentileza desconsidere esta mensagem e nos envie o comprovante.`,
                            ``,
                            `Contamos com sua compreensão e colaboração.`,
                            `*DAL COTONE MS*`,
                          ];
                          textoFinal = linhas.join('\n');
                        }
                        window.open(`https://wa.me/${num}?text=${encodeURIComponent(textoFinal)}`, '_blank');
                      }}
                      data-testid={`recobranca-whatsapp-${d.id}`}>
                      <Phone className="h-4 w-4" /> WhatsApp
                    </Button>
                  )}
                  {isAdmin && ((d.valor_total || 0) - (d.valor_pago || 0)) > 0 && (
                    <Button size="sm" variant="outline" className="gap-1 text-yellow-700 border-yellow-400 bg-yellow-50 hover:bg-yellow-100 font-semibold"
                      onClick={() => openDevolucao(d)} data-testid={`btn-devolucao-recobranca-${d.id}`}>
                      <RotateCcw className="h-4 w-4" /> Devolução
                    </Button>
                  )}
                </div>
                {/* Observações de devoluções (recobrança) */}
                {d.devolucoes && d.devolucoes.length > 0 && (
                  <div className="mt-3 space-y-1" data-testid={`recobranca-devolucoes-${d.id}`}>
                    {d.devolucoes.map((dev, idx) => (
                      <div key={dev.id || idx} className="flex items-center gap-2 bg-yellow-50 border border-yellow-200 rounded-lg px-3 py-1.5">
                        <RotateCcw className="h-3.5 w-3.5 text-yellow-600 flex-shrink-0" />
                        <span className="text-xs text-yellow-800">
                          <strong>Devolução R$ {dev.valor?.toFixed(2)}</strong> — {dev.motivo}
                          <span className="text-yellow-600 ml-1">({dev.data?.split('T')[0]?.split('-').reverse().join('/')})</span>
                        </span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}


      {/* Movimentações Tab */}
      {tab === 'movimentacoes' && resumo && (
        <div className="space-y-2">
          {(resumo.movimentacoes || []).map((m, i) => {
            const isSaida = m.tipo === 'saida';
            const isEntrada = m.tipo === 'entrada';
            const isEntrega = m.tipo === 'entrega_valor';
            const isInvalido = m.invalido === true;
            const colorClass = isInvalido ? 'border-l-gray-300' : isSaida ? 'border-l-red-500' : isEntrada ? 'border-l-amber-500' : isEntrega ? 'border-l-emerald-500' : 'border-l-green-500';
            const valueColor = isInvalido ? 'text-gray-400 line-through' : isSaida ? 'text-red-600' : isEntrada ? 'text-amber-600' : isEntrega ? 'text-emerald-600' : 'text-green-600';
            const bgClass = isInvalido ? 'bg-gray-50 opacity-60' : isSaida ? 'bg-red-50/50' : isEntrega ? 'bg-emerald-50/50' : '';
            return (
              <Card key={m.id || i} className={`border-l-4 ${colorClass} ${bgClass} hover:shadow-sm transition-shadow`}>
                <CardContent className="p-3 flex justify-between items-center">
                  <div className="flex items-center gap-3">
                    <div className={`p-1.5 rounded-lg ${isInvalido ? 'bg-gray-100' : isSaida ? 'bg-red-100' : isEntrega ? 'bg-emerald-100' : isEntrada ? 'bg-amber-100' : 'bg-green-100'}`}>
                      {isSaida ? <TrendingDown className={`h-4 w-4 ${isInvalido ? 'text-gray-400' : 'text-red-600'}`} /> : isEntrega ? <HandCoins className="h-4 w-4 text-emerald-600" /> : <TrendingUp className={`h-4 w-4 ${isInvalido ? 'text-gray-400' : 'text-green-600'}`} />}
                    </div>
                    <div>
                      <p className={`font-medium text-sm ${isInvalido ? 'text-gray-400 line-through' : ''}`}>
                        {isSaida ? `Saída - ${catLabel[m.categoria] || m.categoria}` 
                         : isEntrada ? `Entrada - ${formaLabel[m.forma_pagamento] || m.forma_pagamento}` 
                         : isEntrega ? 'Entrega de Valor (Escritório)'
                         : `Recebimento - ${formaLabel[m.forma_pagamento] || m.forma_pagamento}`}
                        {isInvalido && <span className="ml-2 text-xs bg-red-100 text-red-600 px-1.5 py-0.5 rounded no-underline inline-block" style={{textDecoration:'none'}}>INVÁLIDO</span>}
                      </p>
                      <p className={`text-xs ${isInvalido ? 'text-gray-300' : 'text-gray-500'}`}>
                        {m.cliente_nome || m.registrado_por} | {toCG(m.created_at)}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    {m.imagem_path && (
                      <Button variant="outline" size="sm" onClick={() => handleViewReciboSaida(m)} className="gap-1 text-purple-600 hover:bg-purple-50" data-testid={`btn-recibo-mov-${m.id || i}`}>
                        <Receipt className="h-3 w-3" /> Recibo
                      </Button>
                    )}
                    {isAdmin && !m.is_entrada && !isEntrega && (
                      <Button variant="ghost" size="sm" onClick={() => { setMovToDelete(m); setDeleteMovDialog(true); }} className="h-8 w-8 p-0 text-red-500 hover:text-red-700 hover:bg-red-50" data-testid={`btn-delete-mov-${m.id || i}`}>
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    )}
                    {isAdmin && isSaida && (
                      <Button variant="outline" size="sm"
                        onClick={() => setSaidasVerificadas(prev => ({...prev, [m.id || i]: !prev[m.id || i]}))}
                        className={`gap-1 text-xs ${saidasVerificadas[m.id || i] ? 'bg-green-50 text-green-700 border-green-300 hover:bg-green-100' : 'text-gray-500 hover:bg-gray-50'}`}
                        data-testid={`btn-verificado-saida-${m.id || i}`}>
                        {saidasVerificadas[m.id || i] ? <CheckCircle2 className="h-3.5 w-3.5" /> : <Circle className="h-3.5 w-3.5" />}
                        {saidasVerificadas[m.id || i] ? 'Verificado' : 'Verificar'}
                      </Button>
                    )}
                    <p className={`font-bold text-base ${valueColor}`}>
                      {isSaida ? '-' : '+'}R$ {(m.valor || 0).toFixed(2)}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
          {(resumo.movimentacoes || []).length === 0 && (
            <Card className="border-dashed"><CardContent className="py-10 text-center text-gray-400">
              <TrendingUp className="h-8 w-8 mx-auto mb-2 opacity-50" />
              <p>Nenhuma movimentação registrada.</p>
            </CardContent></Card>
          )}
        </div>
      )}

      {/* Config Dialog (Admin) */}
      <Dialog open={configDialog} onOpenChange={setConfigDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>{novoCaixaMode ? 'Novo Caixa' : 'Configurar Caixa'}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <div>
              <Label>Nome do Caixa</Label>
              <Input value={configForm.nome} onChange={e => setConfigForm({...configForm, nome: e.target.value})} placeholder="Ex: Caixa Principal, Rota Norte..." data-testid="config-nome-input" />
            </div>
            <div>
              <Label>Rota</Label>
              <select value={configForm.rota_id} onChange={e => setConfigForm({...configForm, rota_id: e.target.value})} className="w-full px-3 py-2 border rounded-md" data-testid="config-rota-select">
                <option value="">Selecione uma rota</option>
                {rotas.map(r => <option key={r.id} value={r.id}>{r.nome}</option>)}
              </select>
            </div>
            <div>
              <Label>Período Início</Label>
              <Input type="date" value={configForm.periodo_inicio} onChange={e => setConfigForm({...configForm, periodo_inicio: e.target.value})} data-testid="config-inicio-input" />
            </div>
            <div>
              <Label>Período Fim</Label>
              <Input type="date" value={configForm.periodo_fim} onChange={e => setConfigForm({...configForm, periodo_fim: e.target.value})} data-testid="config-fim-input" />
            </div>
            <Button onClick={handleSaveConfig} className="w-full" data-testid="save-config-btn">{novoCaixaMode ? 'Criar Caixa' : 'Salvar Configuração'}</Button>
            {isAdmin && !novoCaixaMode && (
              <Button variant="outline" onClick={() => { setNovoCaixaMode(true); setConfigForm({ rota_id: '', periodo_inicio: '', periodo_fim: '', nome: '' }); }} className="w-full gap-1" data-testid="novo-caixa-btn">
                + Novo Caixa
              </Button>
            )}
            {novoCaixaMode && (
              <Button variant="ghost" onClick={() => { setNovoCaixaMode(false); if (config) setConfigForm({ rota_id: config.rota_id || '', periodo_inicio: config.periodo_inicio || '', periodo_fim: config.periodo_fim || '', nome: config.nome || '' }); }} className="w-full">
                Cancelar
              </Button>
            )}

            {/* Gerenciar Caixas existentes (admin/secretário) */}
            {isAdmin && !novoCaixaMode && caixas.length > 0 && (
              <div className="pt-3 border-t">
                <p className="text-xs font-semibold text-gray-600 mb-2 uppercase tracking-wide">Gerenciar Caixas</p>
                <div className="space-y-1.5 max-h-48 overflow-y-auto">
                  {caixas.map(cx => (
                    <div key={cx.id} className={`flex items-center justify-between gap-2 p-2 rounded-lg border ${cx.oculto ? 'bg-gray-100 border-gray-300' : 'bg-white border-gray-200'}`} data-testid={`gerenciar-caixa-${cx.id}`}>
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-semibold truncate">{cx.nome || 'Caixa'}</p>
                        <p className="text-[10px] text-gray-500 truncate">{cx.rota_nome || 'Sem rota'}</p>
                      </div>
                      <div className="flex items-center gap-1 flex-shrink-0">
                        {cx.oculto && <span className="text-[9px] bg-gray-500 text-white px-1.5 py-0.5 rounded font-bold">OCULTO</span>}
                        <button
                          onClick={() => handleToggleOcultar(cx.id, cx.oculto)}
                          className={`p-1.5 rounded ${cx.oculto ? 'bg-gray-200 text-gray-700 hover:bg-gray-300' : 'bg-indigo-100 text-indigo-700 hover:bg-indigo-200'}`}
                          title={cx.oculto ? 'Mostrar para vendedores' : 'Ocultar de vendedores'}
                          data-testid={`btn-ocultar-${cx.id}`}
                        >
                          {cx.oculto ? <EyeOff className="h-3.5 w-3.5" /> : <Eye className="h-3.5 w-3.5" />}
                        </button>
                        <button
                          onClick={() => handleExcluirCaixa(cx.id, cx.nome || 'Caixa')}
                          className="p-1.5 rounded bg-red-100 text-red-600 hover:bg-red-200"
                          title="Excluir caixa"
                          data-testid={`btn-excluir-${cx.id}`}
                        >
                          <Trash2 className="h-3.5 w-3.5" />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>

      {/* Pagamento Dialog */}
      <Dialog open={pagDialog} onOpenChange={setPagDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Registrar Pagamento</DialogTitle></DialogHeader>
          {pagPromissoria && (
            <div className="space-y-4">
              <div className="bg-gray-50 p-3 rounded-md">
                <p className="font-bold">{pagPromissoria.cliente_nome}</p>
                <p className="text-sm">Restante: <strong className="text-red-600">R$ {((pagPromissoria.valor_total || 0) - (pagPromissoria.valor_pago || 0)).toFixed(2)}</strong></p>
              </div>

              <div>
                <Label>Forma de Pagamento</Label>
                <div className="grid grid-cols-2 gap-2 mt-1">
                  {Object.entries(formaLabel).map(([key, label]) => {
                    const Icon = formaIcon[key];
                    return (
                      <button key={key} onClick={() => setPagForma(key)} data-testid={`pag-forma-${key}`}
                        className={`flex items-center gap-2 p-3 rounded-lg border-2 transition-all ${pagForma === key ? 'border-blue-500 bg-blue-50 text-blue-700' : 'border-gray-200 hover:border-gray-300'}`}>
                        <Icon className="h-5 w-5" />
                        <span className="text-sm font-medium">{label}</span>
                      </button>
                    );
                  })}
                </div>
              </div>

              <div>
                <Label>Valor (R$)</Label>
                <Input type="number" step="0.01" value={pagValor} onChange={e => setPagValor(e.target.value)} placeholder="0.00" data-testid="pag-valor-input" />
              </div>

              <div>
                <Label>Comprovante (Foto)</Label>
                <div className="flex gap-2 mt-1">
                  <input ref={pagFileRef} type="file" accept="image/*,.pdf" className="hidden" onChange={e => setPagImagem(e.target.files[0])} />
                  <input ref={pagCameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={e => setPagImagem(e.target.files[0])} />
                  <Button type="button" variant="outline" className="flex-1 gap-2" onClick={() => pagFileRef.current?.click()} data-testid="pag-upload-btn">
                    <Upload className="h-4 w-4" /> Upload
                  </Button>
                  <Button type="button" variant="outline" className="flex-1 gap-2" onClick={() => pagCameraRef.current?.click()} data-testid="pag-camera-btn">
                    <Camera className="h-4 w-4" /> Câmera
                  </Button>
                </div>
                {pagImagem && <p className="text-xs text-green-600 mt-1">{pagImagem.name}</p>}
              </div>

              <Button onClick={handlePagamento} disabled={pagLoading} className="w-full bg-green-500 hover:bg-green-600" data-testid="confirm-pag-btn">
                {pagLoading ? 'Registrando...' : 'Confirmar Pagamento'}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Saída Dialog */}
      <Dialog open={saidaDialog} onOpenChange={setSaidaDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Registrar Saída</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-gray-500">Saídas são descontadas do saldo DH EM MÃOS</p>

            <div>
              <Label>Categoria</Label>
              <div className="grid grid-cols-2 gap-2 mt-1">
                {Object.entries(catLabel).map(([key, label]) => {
                  const Icon = catIcon[key];
                  return (
                    <button key={key} onClick={() => setSaidaCategoria(key)} data-testid={`saida-cat-${key}`}
                      className={`flex items-center gap-2 p-3 rounded-lg border-2 transition-all ${saidaCategoria === key ? 'border-red-500 bg-red-50 text-red-700' : 'border-gray-200 hover:border-gray-300'}`}>
                      <Icon className="h-5 w-5" />
                      <span className="text-sm font-medium">{label}</span>
                    </button>
                  );
                })}
              </div>
            </div>

            <div>
              <Label>Valor (R$)</Label>
              <Input type="number" step="0.01" value={saidaValor} onChange={e => setSaidaValor(e.target.value)} placeholder="0.00" data-testid="saida-valor-input" />
            </div>

            <div>
              <Label>Comprovante (Foto)</Label>
              <div className="flex gap-2 mt-1">
                <input ref={saidaFileRef} type="file" accept="image/*,.pdf" className="hidden" onChange={e => setSaidaImagem(e.target.files[0])} />
                <input ref={saidaCameraRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={e => setSaidaImagem(e.target.files[0])} />
                <Button type="button" variant="outline" className="flex-1 gap-2" onClick={() => saidaFileRef.current?.click()} data-testid="saida-upload-btn">
                  <Upload className="h-4 w-4" /> Upload
                </Button>
                <Button type="button" variant="outline" className="flex-1 gap-2" onClick={() => saidaCameraRef.current?.click()} data-testid="saida-camera-btn">
                  <Camera className="h-4 w-4" /> Câmera
                </Button>
              </div>
              {saidaImagem && <p className="text-xs text-green-600 mt-1">{saidaImagem.name}</p>}
            </div>

            <Button onClick={handleSaida} disabled={saidaLoading} className="w-full bg-red-500 hover:bg-red-600" data-testid="confirm-saida-btn">
              {saidaLoading ? 'Registrando...' : 'Confirmar Saída'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Recibo Individual (Saídas e Recebimentos) */}
      <Dialog open={reciboIndividualDialog} onOpenChange={setReciboIndividualDialog}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" aria-describedby="recibo-individual-desc">
          <DialogHeader>
            <DialogTitle>
              Recibo - {reciboIndividualData?.tipo === 'saida'
                ? `Saída ${catLabel[reciboIndividualData?.categoria] || ''}`
                : `Recebimento ${formaLabel[reciboIndividualData?.forma_pagamento] || ''}`}
            </DialogTitle>
          </DialogHeader>
          <p id="recibo-individual-desc" className="sr-only">Comprovante da movimentação</p>
          {reciboIndividualData && (
            <div className="space-y-3">
              <div className="bg-gray-50 p-3 rounded-md space-y-1">
                <p className="text-sm"><strong>Valor:</strong> R$ {(reciboIndividualData.valor || 0).toFixed(2)}</p>
                <p className="text-sm"><strong>Registrado por:</strong> {reciboIndividualData.registrado_por}</p>
                <p className="text-sm"><strong>Data:</strong> {toCG(reciboIndividualData.created_at)}</p>
                {reciboIndividualData.cliente_nome && (
                  <p className="text-sm"><strong>Cliente:</strong> {reciboIndividualData.cliente_nome}</p>
                )}
              </div>
              {reciboIndividualData.imagem_path && (
                <div className="border rounded-lg overflow-hidden">
                  {isAdmin && (
                    <div className="bg-gray-50 px-3 py-2 flex justify-end">
                      <Button variant="outline" size="sm" onClick={() => handleDownloadRecibo(reciboIndividualData.imagem_path, reciboIndividualData.forma_pagamento || reciboIndividualData.categoria, reciboIndividualData.valor, reciboIndividualData.cliente_nome)} className="gap-1" data-testid="download-recibo-individual">
                        <Download className="h-3 w-3" /> Baixar
                      </Button>
                    </div>
                  )}
                  <RenderComprovante path={reciboIndividualData.imagem_path} alt="Comprovante" />
                </div>
              )}
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Recibos (Pagamentos de Promissória) */}
      <Dialog open={recibosDialog} onOpenChange={setRecibosDialog}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto" aria-describedby="recibos-caixa-desc">
          <DialogHeader>
            <DialogTitle>Recibos - {recibosCliente}</DialogTitle>
          </DialogHeader>
          <p id="recibos-caixa-desc" className="sr-only">Imagens dos comprovantes de pagamento</p>
          <div className="space-y-4">
            {recibosData.map((pag, idx) => (
              <div key={pag.id || idx} className={`border rounded-lg overflow-hidden ${pag.invalido ? 'border-red-400 bg-red-50' : ''}`}>
                <div className="bg-gray-50 px-3 py-2">
                  <div className="flex justify-between items-center">
                    <div>
                      <p className="text-sm font-medium">{formaLabel[pag.forma_pagamento] || (pag.forma_pagamento || '').toUpperCase()}</p>
                      <p className="text-xs text-gray-500">
                        R$ {(pag.valor || 0).toFixed(2)} | {pag.data ? pag.data.split('T')[0].split('-').reverse().join('/') : (pag.data_pagamento || '').split('-').reverse().join('/')}
                      </p>
                    </div>
                    <Button variant="outline" size="sm" onClick={() => handleDownloadRecibo(pag.imagem_path, pag.forma_pagamento, pag.valor, recibosCliente)} className="gap-1" data-testid={`download-recibo-caixa-${idx}`}>
                      <Download className="h-3 w-3" /> Baixar
                    </Button>
                  </div>
                  {/* Status badges */}
                  <div className="flex gap-2 mt-2 flex-wrap">
                    {pag.verificado && <span className="text-xs bg-green-100 text-green-700 px-2 py-0.5 rounded-full font-semibold flex items-center gap-1"><CheckCircle2 className="h-3 w-3" />Conferido</span>}
                    {pag.invalido && <span className="text-xs bg-red-100 text-red-700 px-2 py-0.5 rounded-full font-semibold">COMPROVANTE INVÁLIDO</span>}
                  </div>
                  {/* Action buttons - admin/secretario only */}
                  {isAdmin && (
                    <div className="flex gap-2 mt-2">
                      <Button variant="outline" size="sm"
                        onClick={async () => {
                          const res = await handleVerificarComprovante(pag.id || pag.mov_id);
                          setRecibosData(prev => prev.map((p, i) => i === idx ? {...p, verificado: res} : p));
                        }}
                        className={`gap-1 text-xs ${pag.verificado ? 'bg-green-50 text-green-700 border-green-300' : 'text-gray-500'}`}
                        data-testid={`btn-conferir-${idx}`}>
                        {pag.verificado ? <CheckCircle2 className="h-3 w-3" /> : <Circle className="h-3 w-3" />}
                        {pag.verificado ? 'Conferido' : 'Conferir'}
                      </Button>
                      <Button variant="outline" size="sm"
                        onClick={async () => {
                          await handleInvalidarComprovante(pag.id || pag.mov_id);
                          setRecibosData(prev => prev.map((p, i) => i === idx ? {...p, invalido: !p.invalido} : p));
                        }}
                        className={`gap-1 text-xs ${pag.invalido ? 'bg-red-50 text-red-700 border-red-300' : 'text-red-500 hover:bg-red-50'}`}
                        data-testid={`btn-invalidar-${idx}`}>
                        {pag.invalido ? 'Restaurar Comprovante' : 'COMPROVANTE INVÁLIDO'}
                      </Button>
                    </div>
                  )}
                </div>
                <RenderComprovante path={pag.imagem_path} alt={`Recibo ${idx + 1}`} />
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Entregar Valor (Admin/Secretário) */}
      <Dialog open={entregaDialog} onOpenChange={setEntregaDialog}>
        <DialogContent aria-describedby="entrega-valor-desc">
          <DialogHeader><DialogTitle>Entregar Valor ao Carro</DialogTitle></DialogHeader>
          <div className="space-y-4">
            <p id="entrega-valor-desc" className="text-sm text-gray-500">Valor entregue pelo escritório/admin ao vendedor do carro para iniciar a rota. Será somado ao DH EM MÃOS.</p>
            <div>
              <Label>Valor (R$)</Label>
              <Input type="number" step="0.01" min="0.01" value={entregaValor} onChange={e => setEntregaValor(e.target.value)} placeholder="0.00" data-testid="entrega-valor-input" />
            </div>
            <Button onClick={handleEntregaValor} disabled={entregaLoading} className="w-full bg-green-600 hover:bg-green-700 gap-2" data-testid="confirm-entrega-btn">
              <HandCoins className="h-4 w-4" />
              {entregaLoading ? 'Registrando...' : 'Confirmar Entrega'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Confirmar exclusão de movimentação */}
      <AlertDialog open={deleteMovDialog} onOpenChange={setDeleteMovDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Excluir Movimentação</AlertDialogTitle>
            <AlertDialogDescription>
              Tem certeza que deseja excluir esta {movToDelete?.tipo === 'saida' ? 'saída' : 'recebimento'} de{' '}
              <strong>R$ {(movToDelete?.valor || 0).toFixed(2)}</strong>?
              {movToDelete?.tipo === 'recebimento' && (
                <span className="block mt-2 text-red-600 font-medium">
                  O pagamento será revertido na promissória do cliente.
                </span>
              )}
              {movToDelete?.imagem_path && (
                <span className="block mt-1 text-gray-500">O comprovante anexado também será removido.</span>
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={() => setMovToDelete(null)}>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={handleDeleteMov} className="bg-red-600 hover:bg-red-700" data-testid="confirm-delete-mov">
              Excluir
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Dialog Zerar Caixa */}
      <Dialog open={zerarDialog} onOpenChange={setZerarDialog}>
        <DialogContent aria-describedby="zerar-caixa-desc">
          <DialogHeader><DialogTitle className="text-red-600">Zerar Caixa</DialogTitle></DialogHeader>
          <p id="zerar-caixa-desc" className="text-sm text-gray-500">Esta ação remove todas as movimentações do caixa atual. As promissórias NÃO serão alteradas.</p>
          <div className="space-y-4">
            <div>
              <Label>Senha de confirmação</Label>
              <Input type="password" value={zerarSenha} onChange={e => setZerarSenha(e.target.value)}
                placeholder="Digite a senha" data-testid="zerar-senha-input" />
            </div>
            <Button onClick={handleZerarCaixa} disabled={zerarLoading || !zerarSenha}
              className="w-full bg-red-600 hover:bg-red-700 gap-2" data-testid="confirm-zerar-btn">
              <Trash2 className="h-4 w-4" />
              {zerarLoading ? 'Zerando...' : 'Confirmar Zerar Caixa'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Debug Recobrança */}
      <Dialog open={debugRecobOpen} onOpenChange={setDebugRecobOpen}>
        <DialogContent className="max-w-4xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-blue-700 flex items-center gap-2">
              <AlertTriangle className="h-5 w-5" /> Debug Recobrança
            </DialogTitle>
          </DialogHeader>
          {debugRecobLoading && <p className="text-gray-500 py-4">Carregando diagnóstico...</p>}
          {!debugRecobLoading && debugRecobData && (
            <div className="space-y-4">
              <div className="bg-gray-50 rounded p-3 text-sm grid grid-cols-2 md:grid-cols-4 gap-2">
                <div><span className="text-gray-500">Hoje:</span> <strong>{debugRecobData.hoje}</strong></div>
                <div><span className="text-gray-500">Período:</span> <strong>{debugRecobData.periodo_inicio} a {debugRecobData.periodo_fim}</strong></div>
                <div><span className="text-gray-500">Limite Recob:</span> <strong>{'<'} {debugRecobData.limite_recobranca}</strong></div>
                <div><span className="text-gray-500">Dívidas período:</span> <strong>{debugRecobData.total_dividas_do_periodo}</strong></div>
                <div><span className="text-green-700">Entram:</span> <strong>{debugRecobData.entram_no_relatorio}</strong></div>
                <div><span className="text-red-700">Não entram:</span> <strong>{debugRecobData.nao_entram}</strong></div>
                <div className="col-span-2"><span className="text-gray-500">Candidatas (pag. no período):</span> <strong>{debugRecobData.candidatas_com_pagamento_no_periodo}</strong></div>
              </div>
              <div className="text-xs text-gray-500 italic">
                Mostra todas as notas com pagamento dentro do período do caixa. ✅ = entra no relatório · ❌ = excluída e o motivo.
              </div>
              <div className="space-y-2">
                {(debugRecobData.notas || []).length === 0 && (
                  <p className="text-center text-gray-500 py-4">Nenhuma nota com pagamento no período.</p>
                )}
                {(debugRecobData.notas || []).map((n) => (
                  <div key={n.promissoria_id} className={`border-l-4 rounded p-3 text-sm ${n.entra_no_relatorio ? 'border-green-500 bg-green-50/40' : 'border-red-500 bg-red-50/40'}`} data-testid={`debug-row-${n.promissoria_id}`}>
                    <div className="flex justify-between items-start">
                      <div className="font-semibold">
                        {n.cliente_nome || '(sem nome)'} · #{n.numero_pedido}
                        {n.rota_nome && n.rota_nome !== '—' && (
                          <span className="ml-2 inline-flex items-center gap-1 bg-purple-100 text-purple-700 border border-purple-200 rounded px-1.5 py-0.5 text-[10px] font-medium align-middle">
                            <MapPin className="h-3 w-3" /> {n.rota_nome}
                          </span>
                        )}
                      </div>
                      <div className="text-xs font-bold">{n.status_label}</div>
                    </div>
                    <div className="text-xs text-gray-600 mt-1">
                      Venc: <strong>{n.data_vencimento || '?'}</strong> · Status: {n.status_nota} · Total: R$ {Number(n.valor_total || 0).toFixed(2)} · Pago no período: <strong className="text-blue-700">R$ {Number(n.total_pago_periodo || 0).toFixed(2)}</strong>
                    </div>
                    {n.carro_id_nota && String(n.carro_id_nota).startsWith('(vazio') && (
                      <div className="text-[11px] text-amber-700 italic mt-0.5">⚠ {n.carro_id_nota}</div>
                    )}
                    <div className="text-xs mt-1">
                      <span className={n.checks.vencida_ha_mais_7d ? 'text-green-700' : 'text-red-700'}>
                        {n.checks.vencida_ha_mais_7d ? '✓' : '✗'} Vencida há +8d
                      </span>
                      {' · '}
                      <span className={n.checks.nao_e_divida_do_periodo ? 'text-green-700' : 'text-red-700'}>
                        {n.checks.nao_e_divida_do_periodo ? '✓' : '✗'} Não é dívida do período
                      </span>
                    </div>
                    <div className="text-xs text-gray-700 mt-1 italic">{n.motivo}</div>
                    <div className="text-xs text-gray-500 mt-1">
                      Pagamentos: {n.pagamentos_periodo.map((p, i) => <span key={i} className="mr-2">{p.data}: R$ {Number(p.valor).toFixed(2)} ({p.forma})</span>)}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog Devolução */}
      <Dialog open={devolucaoDialog} onOpenChange={setDevolucaoDialog}>
        <DialogContent>
          <DialogHeader><DialogTitle>Registrar Devolução</DialogTitle></DialogHeader>
          <p id="devolucao-desc" className="text-sm text-gray-500 mb-2">
            {devolucaoProm && `${devolucaoProm.cliente_nome} — Nota R$ ${devolucaoProm.valor_total?.toFixed(2)}`}
          </p>
          <div className="space-y-4">
            <div>
              <Label>Valor da Devolução (R$)</Label>
              <Input type="number" step="0.01" min="0.01" max={devolucaoProm ? (devolucaoProm.valor_total - (devolucaoProm.valor_pago || 0)) : 0}
                value={devolucaoValor} onChange={e => setDevolucaoValor(e.target.value)}
                placeholder="Ex: 20.00" data-testid="devolucao-valor-input" />
            </div>
            <div>
              <Label>Motivo</Label>
              <select value={devolucaoMotivo} onChange={e => setDevolucaoMotivo(e.target.value)}
                className="w-full px-3 py-2 border rounded-md" data-testid="devolucao-motivo-select">
                <option value="">Selecione o motivo</option>
                <option value="Produto danificado">Produto danificado</option>
                <option value="Produto vencido">Produto vencido</option>
                <option value="Não tinha dinheiro para pagar a nota">Não tinha dinheiro para pagar a nota</option>
              </select>
            </div>
            <Button onClick={handleDevolucao} disabled={devolucaoLoading}
              className="w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold" data-testid="devolucao-confirmar-btn">
              {devolucaoLoading ? 'Registrando...' : 'Confirmar Devolução'}
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Dialog Agendar Atendimento */}
      <Dialog open={agendaDialog} onOpenChange={setAgendaDialog}>
        <DialogContent className="max-w-md" data-testid="agenda-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <CalendarClock className="h-5 w-5 text-indigo-600" />
              Agendar Atendimento
            </DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <div className="text-sm text-gray-600">
              <p className="font-medium text-gray-800">{agendaProm?.cliente_nome}</p>
              <p className="text-xs">Pedido {agendaProm?.numero_pedido} · Venc: {agendaProm?.data_vencimento}</p>
            </div>

            <div>
              <Label className="text-sm font-semibold">Dia da semana *</Label>
              <div className="grid grid-cols-3 gap-2 mt-2">
                {Object.entries(DIAS_SEMANA_LABEL).map(([key, label]) => (
                  <button
                    key={key}
                    type="button"
                    onClick={() => setAgendaDia(key)}
                    className={`px-3 py-2 rounded-md border text-sm font-medium transition-all ${agendaDia === key ? 'bg-indigo-600 text-white border-indigo-600' : 'bg-white text-gray-700 border-gray-300 hover:bg-indigo-50'}`}
                    data-testid={`agenda-dia-${key}`}
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>

            <div>
              <div className="flex items-center justify-between">
                <Label className="text-sm font-semibold">Horário (opcional)</Label>
                {agendaHora && (
                  <button type="button" onClick={() => setAgendaHora('')}
                    className="text-xs text-gray-500 hover:text-gray-700 flex items-center gap-1"
                    data-testid="agenda-clear-hora">
                    <X className="h-3 w-3" /> Limpar
                  </button>
                )}
              </div>
              <select value={agendaHora} onChange={(e) => setAgendaHora(e.target.value)}
                className="w-full px-3 py-2 border rounded-md mt-2 text-sm"
                data-testid="agenda-hora-select">
                <option value="">— Somente o dia —</option>
                {HORAS_AGENDA.map(h => (
                  <option key={h} value={h}>{h}</option>
                ))}
              </select>
              <p className="text-xs text-gray-400 mt-1">De 08:00 às 19:00, intervalos de 15 min.</p>
            </div>

            <div className="flex flex-col-reverse sm:flex-row gap-2 pt-2">
              {agendaProm?.agendamento && (
                <Button variant="outline" onClick={removerAgendamento} disabled={agendaLoading}
                  className="text-red-600 border-red-300 hover:bg-red-50 gap-1"
                  data-testid="agenda-remover-btn">
                  <X className="h-4 w-4" /> Remover
                </Button>
              )}
              <Button variant="outline" onClick={() => setAgendaDialog(false)} className="flex-1"
                data-testid="agenda-cancelar-btn">
                Cancelar
              </Button>
              <Button onClick={salvarAgendamento} disabled={agendaLoading || !agendaDia}
                className="flex-1 bg-indigo-600 hover:bg-indigo-700 text-white gap-1"
                data-testid="agenda-salvar-btn">
                <CalendarClock className="h-4 w-4" />
                {agendaLoading ? 'Salvando...' : 'Salvar'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
